import auth from '../../services/auth'
import Account from '../../services/account'
import MessageDialog from '../../components/message-dialog.vue'
import { de } from 'date-fns/locale'

export default {

  data() {
    return {
      password: undefined,
      passwordRepeat: undefined,
      errorMessage: undefined,
      loading: false,
      password: null,
      passwordLength: 0,
		  containsEightCharacters: false,
      containsNumber: false,
      containsUppercase: false,
		  containsSpecialCharacter: false,
      validPassword: false,
      token: undefined,
      moveMaisId: undefined,
      validPasswordRepeat: false,
      passwordRepeatLength: 0,
      is2FA: false,
      taxId: ""
    }
  },

  computed: {
    type() {
      console.log(this.$route.params.type, "this.$route.params.type");
      return this.$route.params.type;
    }
  },

  mounted() {
        //  let tokenValidate = this.$route.query.token;
  },
  methods: {
    doReset() {
      if (this.is2FA == true) {
        this.formState = 'NEW';
        console.log("movemaisId: ", auth.getMoveMaisId());
        this.$validator.validateAll()
          .then(success => {
            this.loading = auth.resetPassword(this.password, auth.getMoveMaisId())
              .then(data => {
                if (data)
                  return MessageDialog.show({
                    headerClass: 'modal-success',
                    title: 'Definição de senha',
                    message: 'Sua senha foi definida com sucesso!',
                    type: 'OK'
                  }).then(() => {
                    this.$router.push({ name: "login" });
                  })
              })
              .catch(err => {
                console.error(err);
                if (err.data.status.code == 9990)
                  this.errorMessage = "Prazo para redefinição de senha encerrado!";
                else
                  this.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um problema, tente novamente";
              })
          });
      } else {

        this.formState = 'NEW';
        this.$validator.validateAll()
          .then(success => {
            let token = this.$route.query.token;

            console.log(this.password, token, "Dados para redefinição de senha" )
            this.loading = auth.validToken( this.password, token)
              .then(data => {
                console.log(data, "data valid token")
                if (data) {
                  return MessageDialog.show({
                    headerClass: 'modal-success',
                    title: 'Definição de senha',
                    message: 'Sua senha foi definida com sucesso!',
                    type: 'OK'
                  }).then(() => {
                    this.$router.push({ name: "login" });
                  })
                }
                })

            .catch(err => {
              console.error(err);
              if(err.data.status.code == 9990)
                this.errorMessage = "Prazo para redefinição de senha encerrado !";
              else
                this.errorMessage = err.data && err.data.status && err.data.status.message || "Ocorreu um problema, tente novamente";
            })
        });
      }
      },


    // checkPassword() {
    //   this.passwordLength = this.password.length;
		// 	const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    //   if (this.passwordLength > 8) {
    //     this.containsEightCharacters = true;
    //   } else {
    //     this.containsEightCharacters = false;
		// 	}

    //   this.containsNumber = /\d/.test(this.password);
    //   this.containsUppercase = /[A-Z]/.test(this.password);
		// 	this.containsSpecialCharacter = format.test(this.password);

    //   if (this.containsEightCharacters === true &&
		// 			this.containsSpecialCharacter === true &&
		// 			this.containsUppercase === true &&
		// 			this.containsNumber === true) {
		// 				this.validPassword = true;
    //   } else {
    //     this.validPassword = false;
    //   }
    // },

    // checkPasswordRepeat() {
      //   this.passwordRepeatLength = this.passwordRepeat.length;
      // 	const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

      //   if (this.passwordRepeatLength > 8) {
      //     this.containsEightCharacters = true;
      //   } else {
      //     this.containsEightCharacters = false;
      // 	}

      //   this.containsNumber = /\d/.test(this.passwordRepeat);
      //   this.containsUppercase = /[A-Z]/.test(this.passwordRepeat);
      // 	this.containsSpecialCharacter = format.test(this.passwordRepeat);

      //   if (this.containsEightCharacters === true &&
      // 			this.containsSpecialCharacter === true &&
      // 			this.containsUppercase === true &&
      // 			this.containsNumber === true &&
      //       this.validPassword === true &&
      //       this.password == this.passwordRepeat) {
      // 				this.validPasswordRepeat = true;
      //   } else {
      //     this.validPasswordRepeat = false;
      //   }
      // }
    // }
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/password-set.js